"use strict";

var _classCallCheck = require("/app/front/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/app/front/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This class provides the business logic layer for the UAL.
 */

var UAL = /*#__PURE__*/function () {
  /**
   * @param chains          A list of chains the dapp supports.
   *
   * @param appName         The name of the app using the authenticators
   *
   * @param authenticators  A list of authenticator apps that the dapp supports.
   */
  function UAL(chains, appName, authenticators) {
    _classCallCheck(this, UAL);

    this.chains = chains;
    this.appName = appName;
    this.authenticators = authenticators;
  }
  /**
   * Returns an object with a list of initialized Authenticators that returned true for shouldRender()
   * as well as an authenticator that supports autoLogin
   */


  _createClass(UAL, [{
    key: "getAuthenticators",
    value: function getAuthenticators() {
      var availableAuthenticators = this.authenticators.filter(function (authenticator) {
        return authenticator.shouldRender();
      });
      availableAuthenticators.forEach(function (authenticator) {
        return authenticator.init();
      });
      var autoLoginAuthenticator = null;

      if (availableAuthenticators.length === 1) {
        if (availableAuthenticators[0].shouldAutoLogin()) {
          autoLoginAuthenticator = availableAuthenticators[0];
        }
      }

      return {
        availableAuthenticators: availableAuthenticators,
        autoLoginAuthenticator: autoLoginAuthenticator
      };
    }
  }]);

  return UAL;
}();

exports.UAL = UAL;